(() => {
  const key = 'sky300_vehicle_v1';
  const allowed = new Set(['Mazda CX-60 Turbo MHEV', 'Mazda CX-60 PHEV', 'Mazda 6 Primera generación', 'Mazda 3 2.0 MZR', 'Mazda 3 Skyactiv 2.0', 'Mazda 3 Skyactiv 2.5', 'Mazda 6 Skyactiv', 'Mazda CX Skyactiv', 'Mazda CX-3 Skyactiv 2.0', 'Mazda CX-30 Skyactiv 2.0', 'Mazda CX-30 Skyactiv 2.5', 'Mazda CX-5 Skyactiv', 'Mazda 6 Turbo', 'Mazda CX-5 Turbo', 'Mazda CX-9 Turbo', 'Mazda 2 Skyactiv 1.5', 'Mazda 2 Skyactiv 2.0', 'Mazda 6 All New 2.5', 'Mazda CX-50 Skyactiv 2.5', 'Mazda CX-50 Turbo', 'Mazda CX-90 Turbo MHEV', 'Mazda 2 All New 1.5', 'Mazda 3 Skyactiv 2.0 MHEV', 'Mazda CX-30 Skyactiv 2.0 MHEV']);
  let current = '';
  try { current = sessionStorage.getItem(key) || ''; } catch (_) { /* Storage may be blocked. */ }
  if (!allowed.has(current)) current = '';
  const describe = () => {
    let details = {}; try { details = JSON.parse(sessionStorage.getItem('sky300_vehicle_details_v1') || '{}'); } catch (_) {}
    const extra = details.vehicle === current ? [details.year && details.year !== 'unknown' ? details.year : '',details.generation,details.trim].filter(Boolean).join(' · ') : '';
    return current + (extra ? ' · ' + extra : '');
  };
  const render = () => {
    const hybrid = /MHEV|PHEV/.test(current);
    document.querySelectorAll('[data-sky300-tuning]').forEach(node => {
      node.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = hybrid; });
      node.querySelectorAll('[data-sky300-hybrid-warning]').forEach(warning => { warning.hidden = !hybrid; });
    });
    document.querySelectorAll('[data-vehicle-context]').forEach((node) => {
      node.hidden = !current;
      node.querySelector('[data-vehicle-label]').textContent = describe();
    });
  };
  window.Sky300Vehicle = {
    get: () => current,
    describe,
    set(value) {
      current = allowed.has(value) ? value : '';
      try {
        if (current) sessionStorage.setItem(key, current);
        else sessionStorage.removeItem(key);
      } catch (_) { /* The current page remains usable without storage. */ }
      render();
      document.dispatchEvent(new CustomEvent('sky300:vehicle-change', { detail: current }));
    }
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-vehicle-clear]')) {
      window.Sky300Vehicle.set('');
      const change = document.querySelector('[data-finder-model]') || document.querySelector('.header__heading-link');
      change?.focus();
    }
    const link = event.target.closest('a[data-sky300-whatsapp], a[data-finder-help]');
    if (link) {
      const url = new URL(link.href);
      if (url.hostname !== 'wa.me') return;
      const original = link.dataset.sky300BaseText || url.searchParams.get('text') || '';
      link.dataset.sky300BaseText = original;
      const full = describe();
      const label = document.documentElement.lang.startsWith('en') ? 'Vehicle selection (fitment to confirm): ' : 'Vehículo seleccionado (compatibilidad por confirmar): ';
      url.searchParams.set('text', current && !original.includes(current) ? `${original}\n${label}${full}` : original);
      link.href = url.href;
    }
  });
  // Record the customer's stated vehicle, without treating it as verified fitment.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches?.('form[action*="/cart/add"]')) return;
    if (/MHEV|PHEV/.test(current) && form.closest('[data-sky300-tuning]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      const warning = form.closest('[data-sky300-tuning]').querySelector('[data-sky300-hybrid-warning]');
      if (warning) { warning.hidden = false; warning.focus(); }
      return;
    }
    let property = form.querySelector('[data-sky300-vehicle-property]');
    if (!current) { property?.remove(); return; }
    if (!property) {
      property = document.createElement('input');
      property.type = 'hidden';
      property.name = document.documentElement.lang.startsWith('en') ? 'properties[Stated vehicle (fitment to confirm)]' : 'properties[Vehículo indicado (compatibilidad por confirmar)]';
      property.dataset.sky300VehicleProperty = '';
      form.append(property);
    }
    property.value = describe();
  }, true);
  document.addEventListener('shopify:section:load', render);
  render();
})();
